/* global G */
import { modelComposition } from 'trait/composition'
import { pipe } from 'lib/util'
import { withGetterSetter } from 'lib/trait/with'
import { usesGetterSetter } from 'lib/trait/uses'
import fromTimestamp from 'model/_shared/decorator/fromTimestamp'

const descriptor = 'model::xEcoApm::submit'

export default pipe(
  modelComposition(descriptor),
  withGetterSetter(G.DECORATOR),
  usesGetterSetter(G.DECORATOR, {
    timestamp: fromTimestamp('short', 'timestamp'),
  }),
)
